export default {
  title: 'شركات الشحن',
  refNumber: 'الرقم المرجعي',
  balanceAmount: 'المبلغ المستحق',
  add: 'اضافة شركة شحن',
  update: 'تعديل شركة الشحن',
};
